import React from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshIcon } from '@assets/icon';
import './ReconnectBar.scss';

interface ReconnectBarProps {
    onReconnect: () => void;
    isConnecting?: boolean;
}

const ReconnectBar: React.FC<ReconnectBarProps> = ({ onReconnect, isConnecting }) => {
    const { t } = useTranslation();

    return (
        <div className={`reconnect-bar ${isConnecting ? 'connecting' : ''}`}>
           <div className="reconnect-message">
                {t('common.connectionLostRetry')}
           </div>
           <button 
                className="reconnect-retry-btn" 
                onClick={onReconnect}
                disabled={isConnecting}
            >
                <div className={`reconnect-icon ${isConnecting ? 'spin' : ''}`}>
                    <RefreshIcon />
                </div>
                <span>{t('common.retry')}</span>
           </button>
        </div>
    );
};

export default ReconnectBar;
